import styled from 'styled-components'
import type { Props } from './FileUploader'
import * as _ from 'styles/helpers'

const StyledFileUploader = styled.div<Partial<Props>>`
	margin-bottom: ${_.rem(16)};

	/* Third-party overrides */
	.uploadcare--widget__text,
	.uploadcare--widget__button.uploadcare--widget__button_type_open,
	.uploadcare--widget__button.uploadcare--widget__button_type_cancel,
	.uploadcare--widget__button.uploadcare--widget__button_type_remove {
		display: none;
	}
	/* Style the widget container */
	.uploadcare--widget__button {
		background-color: #ffffff;
		color: #0080fe;
		border: 1px solid #0080fe;
		border-radius: 999px;
		padding: ${_.rem(4)} ${_.rem(12)};
		font-size: ${_.rem(13)};
		font-weight: 600;
		transition: background-color 0.2s, color 0.2s;
	}
	.uploadcare--widget__button:hover {
		background-color: #0080fe;
		color: #ffffff;
	}
	.uploadcare--widget__progress {
		color: ${_.COLORS.blue_500};
		border-color: ${_.COLORS.gray_100};
	}
`

export default StyledFileUploader
